import { createFileRoute } from "@tanstack/react-router";
import ColorPaletteGeneratorPage from "@/pages/ColorPaletteGeneratorPage";

export const Route = createFileRoute("/tools/color-palette-generator")({
  component: ColorPaletteGeneratorPage,
});
